import { render, staticRenderFns } from "./NgFiltersChips.vue?vue&type=template&id=5d228c54"
import script from "./NgFiltersChips.vue?vue&type=script&lang=js"
export * from "./NgFiltersChips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports